module.exports = __webpack_public_path__ + "img/el3.64ba0445.gif";